<template>
  <div class="search" :style="{transform:`translateY(${openSearch?0:'100%'})`}">
    <div class="search-header">
      <div style="padding-right:10px;" class="flex-center">
        <div style="font-size:16px;color:#2B2B2B;max-width:65px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;" @click="openCitySelected">{{cityNameFormat(searchCity)}}</div>
        <van-icon name="arrow-down" size="12" style="margin-left:5px;" />
      </div>
      <div style="flex: 1;">
        <van-field ref="search" left-icon="search" clearable v-model="searchValue" placeholder="请输入地址搜索" @input="handleQuery" @clear="handleQuery" />
      </div>
      <div style="padding-left:10px;" @click="cancelSearch">{{form.province?'取消':'地图'}}</div>
    </div>
    <div class="search-list">
      <div class="flex-sa" style="font-size: 16px;color: #4776E3;padding-bottom: 10px;border-bottom:1px solid #F5F5F5">
        <div style="padding-bottom: 15px 0;" class="flex-center" @click="handleOpenSearch(false)">
          <span class="iconfont" style="font-size:13px;margin-right:5px;">&#xe62e;</span>
          <span>地图选址</span>
        </div>
        <div style="padding-bottom: 15px 0;" @click="handleShowIdentification">
          <span class="iconfont" style="font-size:13px;margin-right:5px;">&#xe630;</span>
          <span>地址识别</span>
        </div>
      </div>
      <div class="search-main">
        <div class="search-item" v-show="isDefaultLocation&&!listLoading" @click="handleRegainPhoneLocation">
          <van-icon name="location" color="#0093D0" size="20px" class="location-icon" />
          <div class="search-item-content">
            <div class="--title">选择当前位置</div>
            <div class="--address">需要获取您的地址位置权限</div>
          </div>
          <div class="prompt"></div>
        </div>
        <div class="search-item" v-show="!isDefaultLocation&&!listLoading" @click="positionPhoneClick">
          <van-icon name="location" color="#0093D0" size="20px" class="location-icon" />
          <div class="search-item-content">
            <div class="--title">{{locationPhoneInfo.title}}</div>
            <div class="--address">{{locationPhoneInfo.detailedAddress}}</div>
          </div>
          <div class="prompt">当前位置</div>
        </div>
        <div class="search-item" v-for="(item,index) in list" :key="index" @click="searchItemClick(item)">
          <van-icon name="location" color="#0093D0" size="20px" class="location-icon" />
          <div class="search-item-content">
            <div class="--title">{{item.title}}</div>
            <div class="--address">{{item.address}}</div>
          </div>
          <div class="prompt" v-if="item.prompt">{{item.prompt}}</div>
        </div>
        <!-- <van-empty
          image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
          description="暂无数据"
          image-size="50px"
          v-show="list&&!list.length&&!listLoading&&!isDefaultLocation"
        /> -->
        <van-loading color="rgba(0,0,0,.5)" size="40px" v-show="listLoading" class="loading" />
      </div>
    </div>
  </div>
</template>

<script>
import { Field , Toast , Icon , Empty , Loading , Button } from 'vant';
import { mapSuggestion , geocoder } from '@/api/dispatch/components/search-list.js';
import permission from '@/utils/permission.js'
export default {
  name:'dispatch-search-list',
  props:['map','openSearch','mapCenterInfo','showIdentification','locationPhoneInfo'],
  components:{ 
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Button.name]: Button,
   },
  data(){
    return {
      searchList:[],
      form:{},
      searchValue:'',
      // searchCity:'',  //搜索方位(城市)  例如:深圳
      listLoading:false,
      list:[],
      searchItemActive:{},  //当前点击的搜索项
      mapPanendDisabled:true,  //控制平移结束方法是否执行
      queryTimer:null,  //防抖定时器
    }
  },
  created(){
    document.addEventListener("visibilitychange",this.handleVisibilityChange);
  },
  beforeDestroy(){
    document.removeEventListener("visibilitychange",this.handleVisibilityChange);
  },
  computed:{
    searchCity(){
      return this.mapCenterInfo.city?this.mapCenterInfo.city:''
    },
    isDefaultLocation(){
      console.log('isDefaultLocation',this.locationPhoneInfo.latitude,this.locationPhoneInfo.longitude)
      return (
        (this.locationPhoneInfo.latitude == '22.543099' && this.locationPhoneInfo.longitude == '114.057868') 
        || !this.locationPhoneInfo.latitude || !this.locationPhoneInfo.longitude
      );
    }
  },
  watch:{
    openSearch:{
      handler(nVal,oVal){
        if(nVal&&nVal!=oVal) {
          this.searchValue = '';
          this.list = [];
        }
      },
      immediate:true
    }
  },
  methods:{
    // 检测程序前后台切换及息屏
    handleVisibilityChange(){
      if(!document.hidden)this.handleRegainPhoneLocation({ notMessage:true });
    },
    // 打开城市选择列表
    openCitySelected(){
      this.$bus.emit('showCitySelected',true);
    },
    mountPanend(map){
      map.on('panend',this.mapPanend);
    },
    handleQuery(){
      if(this.queryTimer) {
        clearTimeout(this.queryTimer);
        this.queryTimer = null;
      }
      this.queryTimer = setTimeout(() => {
        this.getList();
      }, 200);
    },
    /** 获取搜索列表 */
    getList(){
      if(!this.searchValue) {
        this.list = [];
        return Promise.resolve(this.list);
      };
      return new Promise(async(resolve,reject)=>{
        try {
          this.list = [];
          this.listLoading = true;
          let { centerCity } = await this.getMapCenter({notSetInfo:true});
          let { data } = await mapSuggestion({keyword:this.searchValue,region:centerCity,policy:1});
          this.list = data;
          this.listLoading = false;
          return Promise.resolve(data);
        } catch (error) {
          this.listLoading = false;
          return Promise.reject(error);
        }
      })
    },
    setLocationPhoneInfo(){
      if(['province','city','detailedAddress','title','latitude','longitude'].every(key=>this.locationPhoneInfo[key])){
        console.log('手机定位信息',JSON.stringify(this.locationPhoneInfo))
        if(this.isDefaultLocation) return Promise.reject();
        return Promise.resolve({
          address:this.locationPhoneInfo.detailedAddress,
          city:this.locationPhoneInfo.city,
          district:this.locationPhoneInfo.district,
          location:{
            lat:this.locationPhoneInfo.latitude,
            lng:this.locationPhoneInfo.longitude
          },
          province:this.locationPhoneInfo.province,
          title:this.locationPhoneInfo.title,
          prompt:'当前位置',
        })
      }else return Promise.reject();
    },
    async getMapCenter(){
      try {
        let { lat , lng } = this.map.getCenter();
        let { result } = await geocoder({location:`${lat},${lng}`,get_poi:1,poi_options:'policy=2'});
        if(!result.pois||!result.pois.length) return Promise.reject({centerCity:''});
        else return Promise.resolve({centerCity:result.address_component.city});
      } catch (error) {
        return Promise.reject(error);
      }
  },
    /** 打开搜索框 */
    handleOpenSearch(boolean){
      this.$emit('update:openSearch',boolean)
    },
    /** 地图平移结束 */
    mapPanend(){
      if(this.mapPanendDisabled) return;
      this.$emit('update:mapCenterInfo',{
        province:this.searchItemActive.province,  //省
        city:this.searchItemActive.city,  //市
        district:this.searchItemActive.district,  //区
        detailedAddress:this.searchItemActive.address,  //详细地址
        title:this.searchItemActive.title,  //标题
        latitude:this.searchItemActive.location.lat,
        longitude:this.searchItemActive.location.lng,
      })
      this.$emit('update:getCenterLoading',false);
      this.mapPanendDisabled = true;
    },
    // 搜索项的点击
    searchItemClick(item) {
      if(item.location.lat == this.mapCenterInfo.latitude && item.location.lng == this.mapCenterInfo.longitude) return this.handleOpenSearch(false);
      this.searchItemActive = item
      this.mapPanendDisabled = false;
      this.map.panTo(new window.TMap.LatLng(item.location.lat, item.location.lng));
      this.$emit('update:getCenterLoading',true);
      this.handleOpenSearch(false);
    },
    async positionPhoneClick(){
      let item = await this.setLocationPhoneInfo();
      this.searchItemClick(item);
    },
    // 地址识别方法
    handleShowIdentification() {
      this.handleOpenSearch(false);
      this.$emit('update:showIdentification',true);
    },
    cancelSearch(){
      this.handleOpenSearch(false);
      // else uni.navigateBack({ delete: 1 });
    },
    // 重新获取手机定位信息
    handleRegainPhoneLocation({ notMessage }){
      this.listLoading = true;
      permission.appPermission({ iosKey:'location', androidKey:'ACCESS_FINE_LOCATION' })
      .then(PermissionResult=>{
        console.log('位置权限成功开启',JSON.stringify(PermissionResult));
        this.handleGetLocation()
        .then(async position => {
          let { result:geocoderResult } = await geocoder({location:`${position.lat},${position.lng}`,get_poi:1,poi_options:'policy=2'});
          this.$emit('update:locationPhoneInfo',{
            province:geocoderResult.address_component.province,  //省
            city:geocoderResult.address_component.city,  //市
            district:geocoderResult.address_component.district,  //区
            detailedAddress:geocoderResult.pois[0].address,  //详细地址
            title:geocoderResult.pois[0].title,  //标题
            latitude:geocoderResult.location.lat,
            longitude:geocoderResult.location.lng,
          });
          this.$nextTick(async()=>{
            await this.getList();
            this.listLoading = false;
          })
          // 将地图中心移动至手机当前位置
          /* this.map.panTo(new window.TMap.LatLng(position.lat, position.lng));
          this.$emit('update:mapCenterInfo',{
            province:geocoderResult.address_component.province,  //省
            city:geocoderResult.address_component.city,  //市
            district:geocoderResult.address_component.district,  //区
            detailedAddress:geocoderResult.pois[0].address,  //详细地址
            title:geocoderResult.pois[0].title,  //标题
            latitude:geocoderResult.location.lat,
            longitude:geocoderResult.location.lng,
          }) */
        })
        .catch(err=>{
          console.log('位置信息获取失败',JSON.stringify(err));
          this.listLoading = false;
          if(!notMessage) {
            this.$dialog.confirm({
              title:'权限提示',
              message:'请在手机中开启定位信息权限',
            }).then(()=>{
              permission.goSystemAppSetting();
            }).catch(()=>{})
          }
        })
      })
      .catch(err=>{
        this.listLoading = false;
        console.log('位置权限开启失败',JSON.stringify(err))
        if(!notMessage) {
          this.$dialog.confirm({
            title:'权限提示',
            message:'请在手机中开启定位信息权限',
          }).then(()=>{
            permission.goSystemAppSetting();
          }).catch(()=>{})
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
 .search {
    position: fixed !important;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    // display: none;
    flex-direction: column;
    transition: all 0.3s;
    display: flex;
  }

  .search-header {
    padding: 15px 22px;
    padding-bottom: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #FFF;
  }
  ::v-deep .search-header .van-field {
    height: 33px;
    padding: 0 10px ;
    background-color: #F7F7F7;
    border-radius: 20px;
    overflow: hidden;
    .van-field__left-icon {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .van-field__body {
      height: 100%;
    }
  }
.search-list {
  flex: 1;
  margin: 10px 7px 0 7px;
  padding: 15px;
  padding-bottom: 0;
  border-radius: 10px;
  background: #FFF;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.search-main {
  flex: 1;
  overflow-y: auto;
}

.search-item {
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #F5F5F5;
  .prompt {
    font-size: 13px;
    color: #A4A4A4;
    margin-left: 15px;
  }
  .location-icon {
    flex-shrink: 0;
    margin-right: 10px;
  }
  &-content {
    flex: 1;
    .--title {
      font-size: 16px;
      color: #130A01;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .--address {
      font-size: 13px;
      color: #A4A4A4;
    }
  }
}
  .loading {
    width: 100%;
    margin-top: 32px;
    text-align: center;
  }
</style>